export class ForgeProjectIterationTag {
    constructor(model) {
        this.id = model.id;
        this.featureId = model.featureId;
        this.iterationId = model.iterationId;
        this.messageId = model.messageId;
    }
    toRemote() {
        return {
            ...this,
        };
    }
}
